module.exports = __webpack_public_path__ + "static/media/mindfulness-badge.ba2f64d0.svg";